<script lang="ts" setup>
import { ref } from 'vue'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { getErrorCode } from '@/app/core/composable/general'
import { useI18n } from 'vue-i18n'
import { DBtn, DTextField, DTable, DLoading } from 'front-library'
import {
  getIncreaseReasons,
  IncreaseReasons
} from '@/app/core/services/increase-reasons'

/* router, notifications */
const notifications = useNotificationsStore()
const { t } = useI18n()
usePayrollChange(() => window.location.reload())

/* Datos componente Loading */
const loading = ref(false)

/* Datos */
const search = ref()
const tableIncreaseReasons = ref(null)

/* Datos componente table */
const columns = ref([
  { name: 'code', title: t('increaseReasons.list.code'), table: 'code' },
  { name: 'name', title: t('increaseReasons.list.name'), table: 'name' },
  {
    name: 'updated_at',
    title: t('increaseReasons.list.lastUpdate'),
    table: 'updated_at'
  }
])
const rows = ref<IncreaseReasons[]>([])
const perPage = ref(0)
const offset = ref(0)
const totalRows = ref(0)
const sortBy = ref('')

/* Listar motivos de aumento */
const increaseReasons = async () => {
  loading.value = true
  try {
    const data: any = await getIncreaseReasons(
      offset.value,
      perPage.value,
      sortBy.value,
      search.value === '' ? undefined : search.value
    )
    rows.value = data.results
    totalRows.value = data.totalItems
    loading.value = false
  } catch (error: any) {
    loading.value = false
    const code = getErrorCode(error.response.data?.code)
    notifications.addNotification({
      title: t('error.titles.' + code),
      text: t('error.messages.' + code),
      type: 'error',
      time: 10000
    })
  }
}
</script>
<template>
  <DLoading v-show="loading" :message="t('loading.data')" />
  <div class="h-full px-5 overflow-auto scroll">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow"
          v-html="t('increaseReasons.list.title')" />
        <p
          class="text-gray-500 text-shadow"
          v-html="t('increaseReasons.list.description')" />
      </div>
      <div class="sm:flex justify-between pt-8">
        <div class="flex mb-3 sm:mb-0 max-w-2xl sm:w-2/3 md:w-1/2 lg:w-5/12">
          <DTextField
            :placeholder="t('form.button.search') + '...'"
            :icon="'SearchLgIcon'"
            class="mr-2 w-full"
            v-model="search"
            @keyup.enter="increaseReasons" />
          <DBtn
            @click.prevent="increaseReasons"
            v-html="t('form.button.search')" />
        </div>
      </div>
    </div>
    <DTable
      ref="tableIncreaseReasons"
      :columns="columns"
      :rows="rows"
      :total-rows="totalRows"
      :select-options="false"
      :text-no-data="t('table.noData')"
      :text-per-page="t('table.rowsPerPage')"
      @perPage=";(perPage = $event), increaseReasons()"
      @offset="offset = $event"
      @sort=";(sortBy = $event), increaseReasons()">
    </DTable>
  </div>
</template>
